import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Form, Field } from 'react-final-form'
import { RichText } from 'elentari'
import comentariosRepository from './ComentariosRepository'
import { Button } from '@material-ui/core'
import { getUsuarioNome } from '../../utils/Utils'
import h2p from 'html2plaintext'
import toolbarConfig from './ToolbarConfig'

const ComentarioForm = ({ onSubmit, ...props }) => {
  const validate = data => {
    return {
      texto:
        data.texto && data.texto.trim() && !!h2p(data.texto)
          ? undefined
          : 'Obrigatório'
    }
  }

  const handleSubmit = async data => {
    const chatId = props.chatId
    const response = await comentariosRepository.create({
      ...data,
      chatId,
      usuario: getUsuarioNome()
    })
    if (onSubmit) {
      onSubmit(response)
    }
  }

  return (
    <Form onSubmit={handleSubmit} validate={validate}>
      {({ handleSubmit, submitting, form }) => (
        <form
          onSubmit={event => {
            const promise = handleSubmit(event)
            promise &&
              promise.then(() => {
                form.resetFieldState('texto')
                form.reset()
              })
            return promise
          }}
        >
          <Grid container spacing={2}>
            <Grid item sm={12} xs={12}>
              <Field
                fullWidth
                name="texto"
                label="Comentário"
                component={RichText}
                toolbarConfig={toolbarConfig}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="baseline"
                spacing={2}
              >
                <Grid item sm={4} xs={12}>
                  <Button
                    fullWidth
                    type="submit"
                    disabled={submitting}
                    variant="contained"
                    color="primary"
                  >
                    Comentar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      )}
    </Form>
  )
}

export default ComentarioForm
